import { Box } from '@mui/material';
import { GridSortDirection } from '@mui/x-data-grid-premium';
import IncDataGrid, {
  IncDataGridProps,
} from 'components/inc-data-grid/inc-data-grid.component';
import { useSearchParamsContext, useSearchQueryContext } from '../search.hooks';

export type SearchDataGridProps = {
  'data-testid'?: string;
  resizable?: boolean;
  queryName?: string;
} & Partial<IncDataGridProps>;

const SearchDataGrid = ({
  columns,
  'data-testid': dataTestId = 'SearchDataGrid',
  onRowClick,
  resizable = true,
  pagination = true,
  initialState = {},
  queryName,
  ...rest
}: SearchDataGridProps) => {
  const { searchParams, setParamValue, setPaginationModel, removeParams } =
    useSearchParamsContext();
  const {
    paging,
    searchResults,
    queryState: { isFetching },
  } = useSearchQueryContext(queryName);

  return (
    <Box display="flex" flexDirection="column">
      <IncDataGrid
        data-testid={dataTestId}
        resizable={resizable}
        rows={searchResults ?? []}
        columns={columns}
        loading={isFetching}
        pagination={pagination}
        paginationMode={pagination ? 'server' : undefined}
        rowCount={paging?.total ?? 0}
        paginationModel={{
          page: searchParams.page.value as number,
          pageSize: searchParams.count.value as number,
        }}
        onPaginationModelChange={newPaginationModel =>
          setPaginationModel(newPaginationModel)
        }
        initialState={{
          sorting: {
            sortModel: [
              {
                field: searchParams.sortBy?.value as string,
                sort: (
                  searchParams.sortDirection?.value as string
                )?.toLowerCase() as GridSortDirection,
              },
            ],
          },
          ...initialState,
        }}
        sortingMode="server"
        onSortModelChange={newModel => {
          if (newModel.length > 0) {
            setParamValue('sortBy', newModel[0]?.field);
            setParamValue('sortDirection', newModel[0]?.sort.toUpperCase());
          } else {
            removeParams(['sortBy', 'sortDirection']);
          }
        }}
        onRowClick={onRowClick}
        {...rest}
      />
    </Box>
  );
};

export default SearchDataGrid;
